<template>
  <div class="slot-filters-by-days">
    <span>
      <img class="icon-left" src="@ridmv/web-themes/images/icons/arrow-left-solid.svg" alt="">
      <button class="app-btn-link" :disabled="myPage === 0" @click.prevent="page(-1)">
        Previous {{ numOfDays }} days
      </button>
    </span>
    <span>
      <button class="app-btn-link" :disabled="myPage === (numOfPages - 1)" @click.prevent="page(1)">
        Next {{ numOfDays }} days
      </button>
      <img class="icon-right" src="@ridmv/web-themes/images/icons/arrow-right-solid.svg" alt="">
    </span>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';

// Props 
const props = defineProps({
  pageIndex: {
    type: Number,
    required: true,
  },
});

// Emits
const emit = defineEmits(['doFilters']);

// Store 
const store = useStore();

// Reactive State 
const numOfDays = ref('few');   // visual fallback
const numOfPages = ref(0);
const myPage = ref(props.pageIndex);

// Computed properties
const resCurrentDays = computed(() => store.state.user.resCurrentDays);
const resSlottedWeeks = computed(() => store.state.user.resSlottedWeeks);

// Watchers
watch(() => props.pageIndex, (newPage) => {
  myPage.value = newPage;
});

watch(resCurrentDays, (newDays) => {
  numOfDays.value = newDays.length;
});

watch(resSlottedWeeks, (newWeeks) => {
  numOfPages.value = (numOfDays.value === 3) ? newWeeks.length * 2 : newWeeks.length;
});

// Methods 
function page (dir) {
  myPage.value = myPage.value + dir;
  emit('doFilters', { page: myPage.value });
}
</script>

<style scoped lang="scss">
.slot-filters-by-days {
  margin-left: auto;
  span {
    &:first-child {
      margin-right: 0.5em;
    }
    &:nth-child(2) {
      margin-left: 0.5em;
    }
  }
  button {
    margin-bottom: 0.5em;
    padding: 0.25em;
  }
  img {
    @extend %color-blue;
    margin-top: 0;
    margin-bottom: -0.25em;
    width: 16px;
    &.icon-left {
      margin-left: 0;
      margin-right: 0.15em;
    }
    &.icon-right {
      margin-left: 0.15em;
      margin-right: 0;
    }
  }
  .app-btn-link[disabled] {
    background-color: transparent;
    -webkit-filter: brightness(.5);
    filter: brightness(.5);
    color: #fff;
    cursor: not-allowed;
    opacity: .7;
  }
}
</style>
